module.exports = __webpack_public_path__ + "static/media/h3.ec6dd64b.png";